"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[239],{

/***/ 8571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ OrderButtons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _atoms_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7997);



const OrderButtons = (props)=>{
    let { prevButtonText , prevButtonDisabled , onPrevButtonPress , nextButtonText , nextButtonDisabled , onNextButtonPress , disclaimer , isLoading  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            disclaimer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "my-4 text-gray-600 font-medium text-center text-sm",
                children: disclaimer
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex",
                children: [
                    prevButtonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        onPress: onPrevButtonPress,
                        size: "lg",
                        disabled: prevButtonDisabled,
                        isLoading: isLoading,
                        children: prevButtonText
                    }),
                    prevButtonText && nextButtonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-4"
                    }),
                    nextButtonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z, {
                        onPress: onNextButtonPress,
                        size: "lg",
                        appearance: "primary",
                        disabled: nextButtonDisabled,
                        isLoading: isLoading,
                        children: nextButtonText
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 2461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ OrderLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1477);
/* harmony import */ var _translator_app_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_translator_app_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _utils_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8734);





const OrderLayout = (props)=>{
    let { children , totalPrice  } = props;
    let { translate  } = (0,_translator_app_react__WEBPACK_IMPORTED_MODULE_1__.useTranslator)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border-t-2",
                children: react__WEBPACK_IMPORTED_MODULE_3__.Children.map(children, (child, i)=>{
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full py-4", {
                            "border-t": i % 2 === 1
                        }),
                        children: child
                    });
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-gray-800 text-xl flex justify-between py-2 border-t-2 font-medium",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: translate("order.total")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: (0,_utils_currency__WEBPACK_IMPORTED_MODULE_4__/* .formatCurrency */ .x)(totalPrice)
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fl": function() { return /* binding */ ReservationStatusEnumType; },
/* harmony export */   "GQ": function() { return /* binding */ OrderStatusEnumType; },
/* harmony export */   "Go": function() { return /* binding */ LanguageEnum; },
/* harmony export */   "Rx": function() { return /* binding */ UnitEnumType; }
/* harmony export */ });
/* unused harmony exports AllergensEnumType, AuthTypeEnum, ConnectionStatusEnum, CountryEnum, DeviceLogOperationEnum, DeviceLogTypeEnum, FirmwareTypeEnum, LockStatusEnum, LockerTemperatureTypeEnum, LogOperationEnum, NotificationTypeEnumType, QuotaTypeEnumType, SeverityEnumType, SortEnumType, UserRoleReferenceTypeEnum */
var AllergensEnumType;
(function(AllergensEnumType) {
    AllergensEnumType[/** Product contains peanuts */ "Peanuts"] = "peanuts";
    AllergensEnumType[/** Product contains nuts */ "Nuts"] = "nuts";
    AllergensEnumType[/** Product contains crustaceans (a type of shellfish) */ "Crustaceans"] = "crustaceans";
    AllergensEnumType[/** Product contains molluscs (a type of shellfish) */ "Molluscs"] = "molluscs";
    AllergensEnumType[/** Product contains fish */ "Fish"] = "fish";
    AllergensEnumType[/** Product contains eggs */ "Eggs"] = "eggs";
    AllergensEnumType[/** Product contains milk */ "Milk"] = "milk";
    AllergensEnumType[/** Product contains gluten */ "Gluten"] = "gluten";
    AllergensEnumType[/** Product contains soya */ "Soya"] = "soya";
    AllergensEnumType[/** Product contains sesame seeds */ "Sesame"] = "sesame";
    AllergensEnumType[/** Product contains celery */ "Celery"] = "celery";
    AllergensEnumType[/** Product contains mustard */ "Mustard"] = "mustard";
    AllergensEnumType[/** Product contains lupin */ "Lupin"] = "lupin";
    AllergensEnumType[/** Product contains sulphur dioxide */ "SulphurDioxide"] = "sulphurDioxide";
})(AllergensEnumType || (AllergensEnumType = {}));
var AuthTypeEnum;
(function(AuthTypeEnum) {
    AuthTypeEnum["Api"] = "api";
    AuthTypeEnum["User"] = "user";
})(AuthTypeEnum || (AuthTypeEnum = {}));
var ConnectionStatusEnum;
(function(ConnectionStatusEnum) {
    ConnectionStatusEnum[/** Device is online */ "Online"] = "Online";
    ConnectionStatusEnum[/** Device is offline */ "Offline"] = "Offline";
})(ConnectionStatusEnum || (ConnectionStatusEnum = {}));
var CountryEnum;
(function(CountryEnum) {
    CountryEnum["Be"] = "be";
    CountryEnum["Nl"] = "nl";
    CountryEnum["Fr"] = "fr";
    CountryEnum["De"] = "de";
    CountryEnum["At"] = "at";
})(CountryEnum || (CountryEnum = {}));
var DeviceLogOperationEnum;
(function(DeviceLogOperationEnum) {
    DeviceLogOperationEnum["State"] = "State";
    DeviceLogOperationEnum["Error"] = "Error";
    DeviceLogOperationEnum["LockerState"] = "LockerState";
    DeviceLogOperationEnum["RequestLockerConfig"] = "RequestLockerConfig";
    DeviceLogOperationEnum["TerminalAction"] = "TerminalAction";
    DeviceLogOperationEnum["RequestLatestVersion"] = "RequestLatestVersion";
    DeviceLogOperationEnum["Unknown"] = "Unknown";
    DeviceLogOperationEnum["GatewayConfigUpdate"] = "GatewayConfigUpdate";
    DeviceLogOperationEnum["LockerUpdate"] = "LockerUpdate";
    DeviceLogOperationEnum["OpenLocks"] = "OpenLocks";
    DeviceLogOperationEnum["ForceUpdate"] = "ForceUpdate";
    DeviceLogOperationEnum["LatestVersion"] = "LatestVersion";
})(DeviceLogOperationEnum || (DeviceLogOperationEnum = {}));
var DeviceLogTypeEnum;
(function(DeviceLogTypeEnum) {
    DeviceLogTypeEnum["Command"] = "Command";
    DeviceLogTypeEnum["Event"] = "Event";
})(DeviceLogTypeEnum || (DeviceLogTypeEnum = {}));
var FirmwareTypeEnum;
(function(FirmwareTypeEnum) {
    FirmwareTypeEnum["GatewayV1"] = "GatewayV1";
    FirmwareTypeEnum["LockControllerV1"] = "LockControllerV1";
    FirmwareTypeEnum["PinpadControllerV1"] = "PinpadControllerV1";
})(FirmwareTypeEnum || (FirmwareTypeEnum = {}));
var LanguageEnum;
(function(LanguageEnum) {
    LanguageEnum["Nl"] = "nl";
    LanguageEnum["Fr"] = "fr";
    LanguageEnum["En"] = "en";
    LanguageEnum["De"] = "de";
})(LanguageEnum || (LanguageEnum = {}));
var LockStatusEnum;
(function(LockStatusEnum) {
    LockStatusEnum[/** Lock is open */ "Open"] = "open";
    LockStatusEnum[/** Lock is closed */ "Closed"] = "closed";
})(LockStatusEnum || (LockStatusEnum = {}));
var LockerTemperatureTypeEnum;
(function(LockerTemperatureTypeEnum) {
    LockerTemperatureTypeEnum[/** Locker does not do any temperature control at all */ "NotCooled"] = "NotCooled";
    LockerTemperatureTypeEnum[/** Locker keeps room temperature (12-25°C) */ "RoomTemperature"] = "RoomTemperature";
    LockerTemperatureTypeEnum[/** Locker keeps refrigerator temperatures (3-6°C) */ "Refrigerated"] = "Refrigerated";
    LockerTemperatureTypeEnum[/** Locker keeps warm temperatures (60-80°C) */ "Heated"] = "Heated";
})(LockerTemperatureTypeEnum || (LockerTemperatureTypeEnum = {}));
var LogOperationEnum;
(function(LogOperationEnum) {
    LogOperationEnum["Received"] = "Received";
    LogOperationEnum["Sent"] = "Sent";
    LogOperationEnum["Opened"] = "Opened";
    LogOperationEnum["Error"] = "Error";
    LogOperationEnum["Created"] = "Created";
    LogOperationEnum["Updated"] = "Updated";
    LogOperationEnum["Deleted"] = "Deleted";
})(LogOperationEnum || (LogOperationEnum = {}));
var NotificationTypeEnumType;
(function(NotificationTypeEnumType) {
    NotificationTypeEnumType[/** Send sms notification */ "Sms"] = "sms";
    NotificationTypeEnumType[/** Send email notification */ "Email"] = "email";
})(NotificationTypeEnumType || (NotificationTypeEnumType = {}));
var OrderStatusEnumType;
(function(OrderStatusEnumType) {
    OrderStatusEnumType[/** Order has been created, not paid */ "Created"] = "Created";
    OrderStatusEnumType[/** Order has been paid */ "Paid"] = "Paid";
    OrderStatusEnumType[/** Order has expired */ "Expired"] = "Expired";
    OrderStatusEnumType[/** Pending order payment has been expired */ "PaymentExpired"] = "PaymentExpired";
    OrderStatusEnumType[/** Order has been canceled manually */ "Canceled"] = "Canceled";
    OrderStatusEnumType[/** Pending order payment has been canceled */ "PaymentCanceled"] = "PaymentCanceled";
    OrderStatusEnumType[/** Order has been refunded, this can only be done manually in the Mollie dashboard */ "Refunded"] = "Refunded";
})(OrderStatusEnumType || (OrderStatusEnumType = {}));
var QuotaTypeEnumType;
(function(QuotaTypeEnumType) {
    QuotaTypeEnumType[/** Quota is of type SMS */ "Sms"] = "SMS";
    QuotaTypeEnumType[/** Quota is of type Reservations */ "Reservations"] = "Reservations";
    QuotaTypeEnumType[/** Quota is of type Customers */ "Customers"] = "Customers";
    QuotaTypeEnumType[/** Quota is of type Emails */ "Emails"] = "Emails";
    QuotaTypeEnumType[/** Quota is of type Users */ "Users"] = "Users";
    QuotaTypeEnumType[/** Quota is of type Products */ "Products"] = "Products";
    QuotaTypeEnumType[/** Quota is of type Uploads */ "Uploads"] = "Uploads";
})(QuotaTypeEnumType || (QuotaTypeEnumType = {}));
var ReservationStatusEnumType;
(function(ReservationStatusEnumType) {
    ReservationStatusEnumType[/** Reservation has been cancelled */ "Cancelled"] = "cancelled";
    ReservationStatusEnumType[/** Reservation has been created */ "Created"] = "created";
    ReservationStatusEnumType[/** A box in the locker has been reserved */ "Reserved"] = "reserved";
    ReservationStatusEnumType[/**
   * Reservation has been ordered in the vending machine, not neccessarily paid. If
   * order gets cancelled or expires it will return to reserved.
   */ "Ordered"] = "ordered";
    ReservationStatusEnumType[/** Reservation ready notifications have been sent */ "Sent"] = "sent";
    ReservationStatusEnumType[/** Reservation has been picked up */ "Completed"] = "completed";
})(ReservationStatusEnumType || (ReservationStatusEnumType = {}));
var SeverityEnumType;
(function(SeverityEnumType) {
    SeverityEnumType["Info"] = "info";
    SeverityEnumType["Success"] = "success";
    SeverityEnumType["Warning"] = "warning";
    SeverityEnumType["Danger"] = "danger";
})(SeverityEnumType || (SeverityEnumType = {}));
var SortEnumType;
(function(SortEnumType) {
    SortEnumType["Asc"] = "asc";
    SortEnumType["Desc"] = "desc";
})(SortEnumType || (SortEnumType = {}));
var UnitEnumType;
(function(UnitEnumType) {
    UnitEnumType[/** Product is expressed in amount */ "Unit"] = "unit";
    UnitEnumType[/** Product/Price is per kilogram */ "Kg"] = "kg";
    UnitEnumType[/** Product/Price is per liter */ "Liter"] = "liter";
})(UnitEnumType || (UnitEnumType = {}));
var UserRoleReferenceTypeEnum;
(function(UserRoleReferenceTypeEnum) {
    UserRoleReferenceTypeEnum[/** An organisation/customer of the viresmo platform */ "Organisation"] = "Organisation";
    UserRoleReferenceTypeEnum[/** A dealer of the viresmo platform */ "Dealer"] = "Dealer";
    UserRoleReferenceTypeEnum[/** A reseller of the viresmo platform */ "Reseller"] = "Reseller";
})(UserRoleReferenceTypeEnum || (UserRoleReferenceTypeEnum = {}));


/***/ }),

/***/ 958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sl": function() { return /* binding */ cancelOrder; },
  "LV": function() { return /* binding */ createOrder; },
  "_n": function() { return /* binding */ getLastOrderCookieName; }
});

// UNUSED EXPORTS: ShopFragment, getOrganisation, getOrganisationAndShop

// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(8687);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var nookies_dist = __webpack_require__(2286);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(3789);
// EXTERNAL MODULE: ./pages/_app.tsx + 70 modules
var _app = __webpack_require__(7479);
;// CONCATENATED MODULE: ./utils/objectid.ts
function objectid_isValidObjectId(id) {
    // check first if undefined
    if (!id) {
        return false;
    }
    // check if id is a valid string
    if (typeof id !== "string") {
        id = id.toString();
    }
    // simply match the id from regular expression
    if (id.match(/^[0-9a-fA-F]{24}$/)) {
        return true;
    } else {
        return false;
    }
}

;// CONCATENATED MODULE: ./utils/api.ts






function getLastOrderCookieName() {
    let organisationPathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return "".concat(constants/* LAST_ORDER_COOKIE_NAME */.ar, "-").concat(organisationPathname);
}
const organisationQuery = "\nquery OrganisationQuery($pathname: String!) {\n  getOrganisationByWoytiPathname(pathname: $pathname) {\n    _id\n    name\n    brandColor\n    logoUrl\n    pathname\n    vatNumber\n    companyName\n  }\n}\n";
async function getOrganisation(ctx) {
    let { query  } = ctx;
    let organisationPathName = query.organisation;
    let data = await request(GRAPHQL_ENDPOINT, organisationQuery, {
        pathname: organisationPathName
    });
    let organisation = data.getOrganisationByWoytiPathname;
    if (!organisation) {
        console.log("No organisation found for pathname: ".concat(organisationPathName));
        return null;
    } else {
        let graphqlClient = new GraphQLClient(GRAPHQL_ENDPOINT, {
            headers: {
                organisation: organisation._id
            }
        });
        return {
            organisation,
            graphqlClient
        };
    }
}
const ReservationFragment = "\nfragment productFields on ProductObjectType {\n	_id\n	id\n	imageUrl\n	name {\n		language\n		value\n	}\n	description {\n		language\n		value\n	}\n	allergens\n	hasNutritionalInformation\n	nutritionalInformation {\n		energy\n		fat\n		saturatedFat\n		cholesterol\n		carbohydrate\n		fiber\n		sugars\n		addedSugars\n		protein\n		salt\n	}\n	unitType\n}\n\nfragment reservationFields on WoytiReservationObjectType {\n  _id\n  id\n  status\n  isVendingReservation\n  vendingProducts {\n		product {\n			...productFields\n			includedProducts {\n			  product {\n			  	...productFields\n			  }\n			  amount\n		  }\n	  }\n	  amount\n  }\n	vendingTotalPrice\n	vendingDiscount\n}\n";
const ShopFragment = "\nfragment shopFields on WoytiShopObjectType {\n  _id\n  name\n  phonenumber\n  email\n  vendingPickupTime\n  woytiReservationsCount\n  address {\n	  street\n	  streetNumber\n	  zipcode\n	  city\n	  state\n	  country\n  }\n  organisation {\n    _id\n    pathname\n    logoUrl\n  }\n  webshopUrl\n}\n";
const serviceLocationQuery = "\n".concat(ReservationFragment, "\n\n").concat(ShopFragment, "\n\nquery ShopQuery($id: ObjectId!, $shoppingCartItems: [ObjectId!]!) {\n  getWoytiShopById(id: $id) {\n    ...shopFields\n  }\n\n  getWoytiReservationsByShopId(shopId: $id, shouldReturnSoldReservations: true) {\n    ...reservationFields\n  }\n\n  getWoytiShoppingCart(items: $shoppingCartItems, shopId: $id) {\n    ...reservationFields\n  }\n}\n");
const getOrderQuery = "\nquery GetOrder($id: ObjectId!, $token: String!) {\n  getOrderByTokenAndId(id: $id, token: $token) {\n    _id\n    id\n    status\n    shopId\n    orderLines {\n      description\n      totalPrice\n      discountPercentage\n    }\n    pincode\n    totalPrice\n    orderToken\n    payLink\n    createdAt\n    reservations {\n      _id\n      status\n      pickupDateTime\n      updatedStatusAt\n      boxes {\n        lockerId\n        lockerName\n        boxId\n      }\n    }\n  }\n}\n";
async function getOrganisationAndShop(ctx, shopId) {
    let organisationData = await getOrganisation(ctx);
    shopId = Array.isArray(shopId) ? shopId[0] : shopId;
    if (!isValidObjectId(shopId)) {
        serverRedirect("/".concat(ctx.locale || ""), ctx);
        throw new Error("Invalid Shop ID");
    }
    let cookies = parseCookies(ctx);
    let shoppingCart = [];
    if (cookies[SHOPPING_CART_COOKIE_NAME]) {
        try {
            let parsed = JSON.parse(cookies[SHOPPING_CART_COOKIE_NAME]);
            if (parsed.version === APPLICATION_VERSION) {
                let items = parsed.items.filter((reservationId)=>{
                    return typeof reservationId === "string" && isValidObjectId(reservationId);
                });
                shoppingCart = items;
            }
        } catch (err) {
        // do nothing...
        }
    }
    if (!organisationData) {
        return null;
    } else {
        var ref;
        let orderId = null;
        let orderToken = null;
        let lastOrderCookieName = getLastOrderCookieName((ref = organisationData.organisation) === null || ref === void 0 ? void 0 : ref.pathname);
        let lastOrderCookie = cookies[lastOrderCookieName];
        if (ctx.query.orderId && ctx.query.orderToken) {
            orderId = ctx.query.orderId;
            orderToken = ctx.query.orderToken;
        } else if (lastOrderCookie) {
            try {
                let parsed1 = JSON.parse(lastOrderCookie);
                if (parsed1.version === APPLICATION_VERSION) {
                    orderId = parsed1.orderId;
                    orderToken = parsed1.orderToken;
                }
            } catch (err1) {
            // do nothing...
            }
        }
        let graphqlClient = organisationData.graphqlClient;
        let data = await graphqlClient.request(serviceLocationQuery, {
            id: shopId,
            shoppingCartItems: shoppingCart
        });
        if (!data || !data.getWoytiShopById) {
            serverRedirect("/".concat(ctx.locale || ""), ctx);
            throw new Error("Shop not found");
        }
        let order = null;
        if (orderId && isValidObjectId(orderId) && orderToken) {
            try {
                let data1 = await graphqlClient.request(getOrderQuery, {
                    id: orderId,
                    token: orderToken
                });
                var _getOrderByTokenAndId;
                // Expired order
                order = (_getOrderByTokenAndId = data1.getOrderByTokenAndId) !== null && _getOrderByTokenAndId !== void 0 ? _getOrderByTokenAndId : null;
            } catch (err2) {
                await captureException(err2);
            }
            if (!order) {
                destroyCookie(ctx, lastOrderCookieName);
            }
        }
        return {
            organisation: organisationData.organisation,
            graphqlClient,
            order,
            shop: data.getWoytiShopById,
            reservations: data.getWoytiReservationsByShopId,
            shoppingCart: data.getWoytiShoppingCart
        };
    }
}
const CreateOrderMutation = "\nmutation CreateOrderMutation(\n  $firstName: String!\n  $lastName: String!\n  $email: String!\n  $language: LanguageEnum!\n  $items: [ObjectId!]!\n  $shopId: ObjectId!\n) {\n	createWoytiOrder(\n    firstName: $firstName\n    lastName: $lastName\n    email: $email\n    language: $language\n    items: $items\n    shopId: $shopId\n  ) {\n    _id\n    orderToken\n    payLink\n  }\n}\n";
async function createOrder(param) {
    let { firstName , lastName , email , language , items , shopId , organisationId  } = param;
    if (!objectid_isValidObjectId(shopId)) {
        throw new Error("Invalid Shop ID");
    }
    let graphqlClient = new dist.GraphQLClient(constants/* GRAPHQL_ENDPOINT */.Z2, {
        headers: {
            organisation: organisationId
        }
    });
    let data = await graphqlClient.request(CreateOrderMutation, {
        firstName,
        lastName,
        email,
        language,
        items,
        shopId
    });
    return data.createWoytiOrder;
}
const CancelOrderMutation = "\nmutation CancelOrderMutation(\n  $id: ObjectId!\n  $token: String!\n) {\n	cancelOrderUsingToken(\n    id: $id\n    token: $token\n  ) {\n    _id\n  }\n}\n";
async function cancelOrder(param) {
    let { orderId , orderToken , organisationId  } = param;
    if (!objectid_isValidObjectId(orderId)) {
        throw new Error("Invalid Order ID");
    }
    let graphqlClient = new dist.GraphQLClient(constants/* GRAPHQL_ENDPOINT */.Z2, {
        headers: {
            organisation: organisationId
        }
    });
    let data = await graphqlClient.request(CancelOrderMutation, {
        id: orderId,
        token: orderToken
    });
    return data.cancelOrderUsingToken;
}


/***/ }),

/***/ 8734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var currency_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6740);
/* harmony import */ var currency_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(currency_js__WEBPACK_IMPORTED_MODULE_0__);

function formatCurrency(value) {
    let opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let { isCentValue =true , showEuroSign =true  } = opts;
    let amount = isCentValue ? value / 100 : value;
    return currency_js__WEBPACK_IMPORTED_MODULE_0___default()(amount, {
        symbol: showEuroSign ? "€ " : "",
        separator: ".",
        decimal: ","
    }).format().trim();
}


/***/ }),

/***/ 7008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ formatDateTimeString; }
/* harmony export */ });
/* harmony import */ var dayjs_locale_nl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9182);
/* harmony import */ var dayjs_locale_nl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_nl__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6023);
/* harmony import */ var dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_fr__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_en__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5054);
/* harmony import */ var dayjs_locale_en__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_en__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_locale_de__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(790);
/* harmony import */ var dayjs_locale_de__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_de__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);





function formatDateTimeString(date) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "nl";
    return dayjs__WEBPACK_IMPORTED_MODULE_4___default()(date)// @ts-ignore
    .locale(locale).format("DD MMMM YYYY, HH:mm");
}


/***/ })

}]);